// /src/hooks/useCancelAppointments.js
import { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import API from '../api/axiosConfig';

const useCancelAppointment = () => {
    const [cancelError, setCancelError] = useState(null);
    const [isCancelling, setIsCancelling] = useState(false);
    const toast = useToast();

    const cancelAppointment = async (aptData) => {
        setIsCancelling(true);
        setCancelError(null);

        try {
            // aptData should be the JWT token string from appointment.AptData
            if (!aptData) {
                throw new Error('Appointment data is required for cancellation');
            }
            
            console.log("Cancelling appointment with token");
            
            // Use the nested format with the JWT token
            const response = await API.post('/appointments/web/change', {
                cancel: aptData
            });
            
            toast({
                title: "Appointment Cancelled",
                description: "Your appointment has been cancelled successfully.",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
            
            return response.data;

        } catch (error) {
            console.error("Error cancelling appointment:", error);
            
            let description = "There was an error cancelling your appointment. Please try again.";

            if (error.response) {
                if (error.response.status === 403) {
                    const uuid = localStorage.getItem('UUID');
                    toast({
                        title: "Session Expired",
                        description: "Your session has expired. You will be redirected to the login page.",
                        status: "warning",
                        duration: null,
                        isClosable: true,
                    });
                    setTimeout(() => {
                        window.location.href = uuid ? `/${uuid}` : "/";
                    }, 2000);
                } else if (error.response.data?.message) {
                    description = error.response.data.message;
                } else if (error.response.data?.error) {
                    description = error.response.data.error;
                }
            } else if (error.message) {
                description = error.message;
            }

            toast({
                title: "Cancellation Failed",
                description: description,
                status: "error",
                duration: 5000,
                isClosable: true,
            });

            setCancelError(description);
            throw error;
        } finally {
            setIsCancelling(false);
        }
    };

    return { cancelAppointment, isCancelling, cancelError };
};

export default useCancelAppointment;